module.exports = "/_next/static/images/game-3-fingerprint-pointer-14ecdadc3165e3b642e4e3cda443bc7c.png";